import {
  UPDATE_USER_NOTIFICATIONS,
  SET_USER_NOTIFICATIONS,
  UPDATE_NEW_NOTIFICATIONS_COUNT,
  SET_NEW_NOTIFICATIONS_COUNT,
} from '@/store/mutationTypes.js';
import {
  getNotifications,
  getUnreadNotificationCount,
} from '@/api/notification.js';

const state = {
  newNotificationCount: null,
  notificationArray: [],
};

const mutations = {
  [SET_USER_NOTIFICATIONS]: (state, { notificationArray }) => {
    state.notificationArray = notificationArray;
  },

  [SET_NEW_NOTIFICATIONS_COUNT]: (state, { count }) => {
    state.newNotificationCount = count;
  },
};

const actions = {
  [UPDATE_USER_NOTIFICATIONS]: async ({ dispatch, commit }) => {
    const { data, success } = await getNotifications();
    if (success) {
      commit(SET_USER_NOTIFICATIONS, { notificationArray: data.items });
      dispatch(UPDATE_NEW_NOTIFICATIONS_COUNT);
    }
  },

  [UPDATE_NEW_NOTIFICATIONS_COUNT]: async ({ commit }) => {
    const { data, success } = await getUnreadNotificationCount();

    if (success) {
      commit(SET_NEW_NOTIFICATIONS_COUNT, { count: data.count });
    }
  },
};

export default {
  state,
  mutations,
  actions,
};
